import { useTranslation } from 'react-i18next'
import AuthUtil from '../utils/AuthUtil'
import NotificationService from '../service/NotificationService'
import { useEffect } from 'react'
import Private from './Private'
import Helmet from 'react-helmet'
import RemoteOfficeNotification from '../components/remote-office-notification'

export default function RemoteOfficeNotificationPage() {
  const { t } = useTranslation()

  const authorizationCheck = () => {
    let employee = AuthUtil.getEmployeeSummary()
    // Menü ile aynı kural: bu ekran yalnızca yöneticilere (isManager) açıktır.
    if (!employee?.isManager) {
      NotificationService.showUnauthorizedRedirectionPopup(
        10000,
        'Yetkisiz Kullanıcı!',
        'Burayı görüntüleme yetkiniz yok!'
      ).then(() => {
        window.location.href = '/home'
      })
    }
  }

  useEffect(() => authorizationCheck(), [])

  return (
    <Private>
      <Helmet>
        <title>Koç Office Free - {t('nav-menu-items.home-office-request')} </title>
        <meta
          name="description"
          content="Office Free ile ister şirketinden, ister Koç Topluluğu ortak ofislerinden çalışma planı gerçekleştirebilir, istersen de uzaktan çalışma bildirimi yapabilirsin."
        />
      </Helmet>

      <div className="container">
        <RemoteOfficeNotification />
      </div>
    </Private>
  )
}
